<template>
  <div id="dashboard-page" class="mb-5">
    <b-row class="mb-5 mt-2">
      <b-col md="12" class="mt-0">
        <b-card>
          <b-row>
            <b-col md="10">
              <h3>{{$route.name}}</h3>
              <b-breadcrumb>
                <b-breadcrumb-item><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item>
                <b-breadcrumb-item><router-link to="/sales/sales-order">Sales Order</router-link></b-breadcrumb-item>                        
                <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
            <!--<b-col md="2 mt-4">
              <b-button v-b-tooltip.hover.top title="Download to PDF" @click="doExportToPDF" variant="info" class="btn-download float-right"><font-awesome-icon icon="download"/></b-button>
            </b-col>-->
          </b-row>
          <div class="border-bottom mb-5"></div>
          <paginated-table ref="dataTable" :can-edit="false" :can-delete="false" :can-approve="false" :can-reject="false" :can-show="true" :can-show-route-path="'#/sales/sales-order'"  :can-edit-modal="false" :can-paid="false" :data-url="apiUrl.salesOrder" :data-key="dataKey" :data-columns="columns">
          </paginated-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import PaginatedTable from '@/components/PaginatedTable'
export default {
  name: 'sales-order',
  components: {
    PaginatedTable
  },
  data: function() {
    var currentDate = new Date();
    var monthlymonth = new Date(currentDate)
    var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
    var twoDigitFirstDate= ("0" + (monthlymonth.getDate() + 0)).slice(-2);
    var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

    return {
      isLoading: false,
      dataKey: 'sales_order',
      apiUrl: {
        salesOrder: window.AppConfig.apiUrl + 'sales-order?start_date_created=' + createdDateTo + '&end_date_created=' + createdDateTo
      },
      columns: [
        {
          key: 'orderId',
          label: 'Order ID',
          sortable: true
        },
        {
          key: 'customerSales',
          label: 'Customer',
          sortable: true
        },
        {
          key: 'company',
          label: 'Company',
          sortable: true
        },
        {
          key: 'branch',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'requestedBySales',
          label: 'Sales Person',
          sortable: true
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: false
        },
        {
          key: 'status',
          label: 'Status'
        },
        {
          key: 'actionSales',
          label: ''
        }
      ],
      createdDateTo: createdDateTo
    }
  },
  methods: {
    getDateTime (value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A')
      } else {
        return '-'
      }
    },
    getStatusColor (val) {
      switch (val) {
      case 'Requested':
        return 'info'
        // eslint-disable-next-line no-unreachable
        break
      case 'New':
        return 'info'
        // eslint-disable-next-line no-unreachable
        break
      case 'Approved':
        return 'success'
        // eslint-disable-next-line no-unreachable
        break
      case 'Completed':
        return 'success'
        // eslint-disable-next-line no-unreachable
        break
      case 'Rejected':
        return 'danger'
        // eslint-disable-next-line no-unreachable
        break
      case 'Paid':
        return 'primary'
        // eslint-disable-next-line no-unreachable
        break
      case false:
        return 'secondary'
        // eslint-disable-next-line no-unreachable
        break
      case true:
        return 'success'
        // eslint-disable-next-line no-unreachable
        break
      case '0':
        return 'danger'
        // eslint-disable-next-line no-unreachable
        break
      case '1':
        return 'success'
        // eslint-disable-next-line no-unreachable
        break
      }
    }
  }
}
</script>